import { useQuery } from '@tanstack/react-query';

import { GetUserDataDeletionAuditLogs } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getUserDataDeletionAuditLogs: GetUserDataDeletionAuditLogs = () => {
  return axios.get(`/meta/user-data-deletion/audit-log`);
};

type QueryFnType = typeof getUserDataDeletionAuditLogs;

type UseGetUserDataDeletionAuditLogs = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetUserDataDeletionAuditLogs = ({
  config = {},
}: UseGetUserDataDeletionAuditLogs = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['userDataDeletionAuditLogs'],
    queryFn: () => getUserDataDeletionAuditLogs(),
  });
};
